import { Component } from '@angular/core';

@Component({
    selector: 'browser-not-supported',
    template: require('./browser-not-supported.view.html'),
    styles: [require('./browser-not-supported.view.css')],
})
export class BrowserNotSupportedView {
}